module.exports = __webpack_public_path__ + "7eed4ea049c1a205af24f0e75b141a65.svg";